const { InspectorControls } = wp.blockEditor;
const { SelectControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';
import SelectColor from '../wp-controlers/select-color';
import SelectBackground from '../wp-controlers/select-background';

const Inspector = ({ attributes, setAttributes }) => {
  const { colorTitle, padding } = attributes;

  return (
    <InspectorControls>
      <SelectControl
        label="Selecione a cor do título"
        title="Selecione a cor do título"
        value={colorTitle}
        options={[
          { label: 'Branco', value: 'color-white' },
          { label: 'Preto', value: 'color-black' },
          { label: 'Azul', value: 'color-blue' },
          { label: 'Azul Escuro', value: 'color-blue-dark' },
          { label: 'Cinza', value: 'color-grey' },
          { label: 'Cinza claro', value: 'color-grey-soft' },
          { label: 'Cinza Escuro', value: 'color-grey-dark' },
          { label: 'Laranja', value: 'color-orange' },
          { label: 'Verde', value: 'color-green' },
        ]}
        onChange={(position) => setAttributes({ colorTitle: position })}
      />

      <SelectColor attributes={attributes} setAttributes={setAttributes} />
      <SelectBackground attributes={attributes} setAttributes={setAttributes} />

      <SelectControl
        label="Padding deste container"
        title="Padding deste container"
        value={padding}
        options={[
          { label: 'Nenhum', value: 'none' },
          { label: 'Pequeno', value: 'small' },
          { label: 'Médio', value: 'medium' },
          { label: 'Grande', value: 'large' },
        ]}
        onChange={(position) => setAttributes({ padding: position })}
      />

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
